import { z } from 'zod';

export const SequenceItemSchema = z.object({
  id: z.string(),
  sequenceNumber: z.number(),
  active: z.boolean(),
  angle: z.number(),
  title: z.string(),
  color: z.string(),
  hidden: z.boolean(),
});

export type SequenceItem = z.infer<typeof SequenceItemSchema>;

export const SequenceDirectionSchema = z.object({
  color: z.string(),
  active: z.boolean(),
});

export type SequenceDirection = z.infer<typeof SequenceDirectionSchema>;

export const SequenceControlSchema = z.object({
  up: SequenceDirectionSchema,
  down: SequenceDirectionSchema,
});

export type SequenceControl = z.infer<typeof SequenceControlSchema>;